export default "/assets/images/rookieparent-filter.5cf3d2ea5af8a5f4.png";